import { classNames } from "components/library/utils/classNames";
import React from "react";

export const CodeShowcase = ({ size }: { size: 14 | 18 | 24 }) => {
  return (
    <div className="inline-block rounded border  border-gray-800 bg-[#262626] px-12 py-8">
      <div
        className={classNames(
          "flex gap-16 font-mono tracking-wide text-white",
          size === 14 && "text-14-20",
          size === 18 && "text-18-24",
          size === 24 && "text-24-32"
        )}
      >
        <span>&gt;</span> <span className="text-blue-400">humanloop</span>{" "}
        <span>init</span>
        <span className="text-cyan-600">myproject</span>
        {size === 24 && <CursorPrompt height={30} width={14} />}
        {size === 18 && <CursorPrompt height={24} width={12} />}
        {size === 14 && <CursorPrompt height={22} width={8} />}
      </div>
    </div>
  );
};

const CursorPrompt = ({ width, height }: { width: number; height: number }) => {
  //  Cursor prompt rectangle
  /* Blinks 10 times */
  return (
    <svg
      className="-ml-8 inline-block animate-[blink_1s_steps(1,end)_10] text-gray-800"
      width={width}
      height={height}
    >
      <rect width={width} height={height} fill="currentColor" />
    </svg>
  );
};
